module.exports = __webpack_public_path__ + "img/GSF_InitialStyleSketches-scientist-green.48a3a116.png";